// extracted by mini-css-extract-plugin
export default {"wrapper":"News_wrapper__h0whV","container":"News_container__PRs6B"};